/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { BiRupee } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import StarRatings from 'react-star-ratings';
import { getAverageRatingReview } from '../../../services/operations/courseApi';
import { useDispatch } from 'react-redux';

const CourseCard = ({ course, cardHeight }) => {
    const [avgRating, setAvgRating] = useState(0);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAverageRatingReview(setAvgRating, course._id));
    }, [course]);

    return (
        <div className='text-richblack-5 mx-4'>
            <Link to={`/course/${course?.courseName.toLowerCase()}/${course?._id}`}>
                <div style={{ height: cardHeight }} className='bg-richblack-700 rounded-xl'>
                    <img
                        loading='lazy'
                        src={course?.thumbnail}
                        alt={course?.courseName}
                        className={`object-cover rounded-xl w-full h-full`}
                    />
                </div>
                <p className='text-[1.5rem] font-semibold pt-2'>
                    {course?.courseName}
                </p>
                <p className='text-sm text-richblack-200 py-1'>
                    {course?.instructor?.firstName} {course?.instructor?.lastName}
                </p>
                <div className='flex items-center py-2'>
                    {avgRating > 0 &&
                        <span className='text-yellow-50 text-lg pr-2 pt-1'>
                            {avgRating.toFixed(1)}
                        </span>
                    }
                    <StarRatings
                        numberOfStars={5}
                        rating={avgRating}
                        starDimension={'24px'}
                        starSpacing={'1px'}
                        starRatedColor={'#FFD60A'}
                        starEmptyColor={'#6E727F'}
                    />
                    <span className='px-3 text-richblack-300'>
                        {course?.ratingAndReviews?.length} ratings
                    </span>
                </div>
                <p className='flex items-center text-xl'><BiRupee /> {parseInt(course?.price).toLocaleString()}</p>
            </Link>
        </div>
    );
}

export default CourseCard;